import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "labelGen", params: {} } } },
            [_vm._v(" Label Gen ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { to: { name: "labelGenView", params: {} } } },
            [_vm._v(" View Label Gen ")]
          ),
        ],
        1
      ),
      _vm.loaded
        ? _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v(" View Label Gen ")]),
              _c(
                VCardText,
                [
                  _c(VSimpleTable, {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("tbody", [
                                _vm.labelGen.product_id
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Product:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.labelGen.product_id)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.labelGen.brand
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Brand:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.labelGen.brand)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.labelGen.inventory_id
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Label Gen:")]
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.labelGen.inventory_id)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.labelGen.prefix
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Prefix:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.labelGen.prefix)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.labelGen.code
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Code:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.labelGen.code)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.labelGen.weights
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Weights:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.labelGen.weights)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.labelGen.stock_date
                                  ? _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-subtitle-1",
                                          attrs: { "max-width": "35%" },
                                        },
                                        [_vm._v("Stock Date:")]
                                      ),
                                      _c("td", [
                                        _vm._v(_vm._s(_vm.labelGen.stock_date)),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      90827648
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between ma-5" },
        [
          _c(VBtn, { on: { click: _vm.goBack } }, [_vm._v("Back")]),
          _c(
            VBtn,
            {
              attrs: { color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.edit(_vm.id)
                },
              },
            },
            [_vm._v("Edit")]
          ),
          _c("span"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }